// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1_yEH","cls2":"AccountMenu-cls2_esj AccountMenu-cls1_yEH"};